require('./keepAliveModal.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @utilities
const { logoutUser } = require('utilities/LogoutHelper');
const { recordLink } = require('utilities/tagging');

// @actions
const logoutActions = require('actions/logout');

// @components
const OKModal = require('components/commons/OKModal/OKModal');

// @ assets
const inactivityAlert = require('assets/images/session-is-about-to-expire.svg');

// @constants
const { KEEPALIVE_TIME } = require('constants/index');
const { 
    ACTION_EVENT_CLOSE_MODAL,
    TIMEOUT_MODAL_LOGOUT,
    TIMEOUT_MODAL_MAINTAIN_SESSION,
    ACTION_EVENT_VIEW,
    TIMEOUT_MODAL
} = require('constants/tagging');


class KeepAliveModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            time: KEEPALIVE_TIME,
        };

        this.handleClose = this.handleClose.bind(this);
        this.handleEndTimer = this.handleEndTimer.bind(this);
        this.handlePrimaryButtonClick = this.handlePrimaryButtonClick.bind(this);
        this.handleSecondaryButtonClick = this.handleSecondaryButtonClick.bind(this);
        this.startTimer = this.startTimer.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        const { immLogout } = this.props;
        const nextImmLogout = nextProps.immLogout
        const visible = immLogout.get('keepAliveModalVisible');
        const error = immLogout.get('error');
        const nextVisible = nextImmLogout.get('keepAliveModalVisible');
        if (!visible && nextVisible && !error) {
            this.startTimer();
            recordLink(
                window.utag_data.nombrePagina, 
                TIMEOUT_MODAL, 
                ACTION_EVENT_VIEW
            );
        }
        return true;
    }

    redirectToCloseMobileFIOC = () => {
        window.location.href = '/myprofile/global/';
    }

    handleClose() {
        const { keepAlive } = this.props;
        clearInterval(this.timer);
        keepAlive();
        recordLink(
            window.utag_data.nombrePagina, 
            TIMEOUT_MODAL, 
            ACTION_EVENT_CLOSE_MODAL
        );
    }

    handleEndTimer() {
        const { hideKeepAlivePopup } = this.props;
        clearInterval(this.timer);
        hideKeepAlivePopup();
    }

    handlePrimaryButtonClick() {
        const { keepAlive } = this.props;
        clearInterval(this.timer);
        keepAlive();
        recordLink(
            window.utag_data.nombrePagina, 
            TIMEOUT_MODAL, 
            TIMEOUT_MODAL_MAINTAIN_SESSION
        );
    }

    handleSecondaryButtonClick() {
        const { handleLogout, hideKeepAlivePopup, isFIOCMobile, isMigrationMobile } = this.props;
        clearInterval(this.timer);
        hideKeepAlivePopup();
        if (isFIOCMobile || isMigrationMobile) {
            this.redirectToCloseMobileFIOC()
        } else {
            logoutUser(handleLogout);
        }
        recordLink(
            window.utag_data.nombrePagina, 
            TIMEOUT_MODAL, 
            TIMEOUT_MODAL_LOGOUT
        );
    }

    startTimer() {
        clearInterval(this.timer);
        this.setState({
            time: KEEPALIVE_TIME
        }, () => {
            const updateTimer = () => {
                    const { time } = this.state;
                    (time === 0) ? this.handleEndTimer() : this.setState({ time: time - 1 });
                };
            this.timer = setInterval(updateTimer, 1000);
        });
    }

    buildContent() {
        const { time } = this.state;
        return (
            <React.Fragment>
                <div className="keep-alive-modal__primary-text">
                    <FormattedText value="keepAliveModal-headingText" />
                </div>
                <div className="keep-alive-modal__divider"></div>
                <div className="keep-alive-modal__icon-img">
                    <img src={inactivityAlert} className="keep-alive-modal__icon-img--icon" />
                </div>
                <p className="keep-alive-modal__secondary-text">
                    <FormattedText value="keepAliveModal-descriptionText" />
                </p>
                <div className="keep-alive-modal__timer">
                    <span>{`${time}s`}</span>
                </div>
            </React.Fragment>
        );
    }
    
    render() {
        const { immLogout, isFIOCMobile, isMigrationMobile} = this.props;
        const visible = immLogout.get('keepAliveModalVisible');
        const error = immLogout.get('error');
        
        if (!visible || error) return null;

        const content = this.buildContent();

        return (
            <div className="keep-alive-modal">
                <OKModal
                    content={content}
                    contentOverflow="auto"
                    footerType="navigation"
                    isOpen={visible}
                    onCloseCallback={this.handleClose}
                    onPrimaryButtonClick={this.handlePrimaryButtonClick}
                    onSecondaryButtonClick={this.handleSecondaryButtonClick}
                    primaryButtonText={formatText('keepAliveModal-primaryButtonText')}
                    secondaryButtonText={formatText('keepAliveModal-secondaryButton')}
                    overlayClassName="keep-alive-modal-wrapper"
                    overlayBackgroundClassName={`${isFIOCMobile || isMigrationMobile ? 'keep-alive-modaloverlay--fioc-mobile' : ''}`}
                    type="filter"
                />
            </div>
        )
    }
}

KeepAliveModal.propTypes = {
    handleLogout: PropTypes.func.isRequired,
    hideKeepAlivePopup: PropTypes.func.isRequired,
    immLogout: PropTypes.object.isRequired,
    keepAlive: PropTypes.func.isRequired,
    isFIOCMobile: PropTypes.bool,
    isMigrationMobile: PropTypes.bool
};

KeepAliveModal.defaultProps = {
    isFIOCMobile: false,
    isMigrationMobile: false
}

module.exports.constructor = KeepAliveModal;
module.exports.KeepAliveModal = connect(
    state => ({
        immLogout : state.logout,
    }), {
        handleLogout: logoutActions.handleLogout,
        hideKeepAlivePopup: logoutActions.hideKeepAlivePopup,
        keepAlive: logoutActions.keepAlive,
    }
)(KeepAliveModal);
